import Staking from "./Staking";

export default function Yield() {
    return <Staking variant="yield" />;
}
